import { Action, ActionType, Pages, State } from "./types";

export const lostStolenDamagedReducer = (
  state: State,
  action: Action,
): State => {
  switch (action.type) {
    case ActionType.SUCCESS: {
      return {
        page: Pages.SUCCESS,
      };
    }
    case ActionType.REPORT_LOST_STOLEN:
    case ActionType.REPORT_DAMAGED: {
      return {
        address: action.address,
        scheme: action.scheme,
        cardEndsWith: action.cardEndsWith,
        type: action.type,
        lostStolenDamagedUrl: action.lostStolenDamagedUrl,
        page:
          action.type === ActionType.REPORT_LOST_STOLEN
            ? Pages.REPORT_LOST_STOLEN_CONFIRMATION
            : Pages.REPORT_DAMAGED_CONFIRMATION,
      };
    }
    case ActionType.ERROR: {
      return {
        page: Pages.ERROR,
      };
    }
    default: {
      return state;
    }
  }
};
